export default {
  NbaBaseUrl: "https://nbastatsapi.lucaspradel.de"
};
